import React from 'react';
import { Tooltip } from "@material-ui/core";
import Info from '@material-ui/icons/Info';

export const renderToolTip = (key = 'securaze_basic', translations, classes) => {
    let formHelperText = null;
    switch (key) {
        case 'securaze_basic':
            formHelperText = <div><p>{translations['customer_passwords_text_0'] || 'Passwords must be at least 3 characters in length'}</p></div>;
            break;
        case 'securaze_standard':
            formHelperText =
                <div><p>{translations['customer_passwords_text_1'] || 'Passwords must be at least 5 characters in length'}</p><p>
                    {translations['customer_passwords_text_2'] || "Passwords must have at least one upper case"}</p>
                    <p>{translations['customer_passwords_text_3'] || 'Passwords must have at least one lower case'}</p>
                    <p>{translations['customer_passwords_text_4'] || "Passwords must have at least one number"}</p></div>;
            break;
        case 'microsoft':
            formHelperText =
                <div><p>{translations['customer_passwords_text_5'] || 'Passwords must be at least 8 characters in length'}</p>
                    <p>{translations['customer_passwords_text_3'] || 'Passwords must have at least one lower case'}</p>
                    <p>{translations['customer_passwords_text_4'] || "Passwords must have at least one number"}</p>
                    <p>{translations['customer_passwords_text_2'] || "Passwords must have at least one upper case"}</p>
                    <p>{translations['customer_passwords_text_6'] || 'Passwords must have at least one special character'}</p>
                    <p>{translations['customer_passwords_text_7'] || 'Password should not contain user or customer name'}</p></div>;
            break;
        case 'nist':
            formHelperText =
                <div><p>{translations['customer_passwords_text_5'] || 'Passwords must be at least 8 characters in length'}</p>
                    <p>{translations['customer_passwords_text_2'] || "Passwords must have at least one upper case"}</p>
                    <p>{translations['customer_passwords_text_3'] || 'Passwords must have at least one lower case'}</p>
                    <p>{translations['customer_passwords_text_4'] || "Passwords must have at least one number"}</p>
                    <p>{translations['customer_passwords_text_6'] || "'Passwords must have at least one special character"}</p>+
                    <p>{translations['customer_passwords_text_7'] || 'Password should not contain user or customer name'}</p>
                    <p>{translations['customer_passwords_text_8'] || 'Passwords must not contain repetitive characters'}</p></div>;
            break;
        default:
            formHelperText = <div><p>{translations['customer_passwords_text_0'] || 'Passwords must be at least 3 characters in length'}</p></div>;
            break;
    }
    return <Tooltip title={formHelperText} className={classes} placement='right-start'>
        <Info />
    </Tooltip>
};

export const renderToolTipNamespace = (translations, classes) => {
    let formHelperText =
        <div><p>{translations['namespace_text'] || 'Namespace may only contain lowercase letters, numbers and - or _'}</p>   </div>;

    return <Tooltip title={formHelperText} className={classes} placement='right-start'>
        <Info />
    </Tooltip>
};

export const billingModes = (translations) => {
    return [{ value: 'prepaid', displayValue: translations['prepaid'] || 'Prepaid' }, { value: 'postpaid', displayValue: translations['contract'] || 'Contract' }];
}
export const accountStatuses = (translations) => {
    return [{ value: 'active', displayValue: translations['active'] || 'Active' },
    { value: 'prepared', displayValue: translations['prepared'] || 'Prepared' },
    { value: 'inactive', displayValue: translations['inactive'] || 'Inactive' },
    { value: 'expired', displayValue: translations['expired'] || 'Expired' }];
}


export const languages = (translations) => {
    return [{ value: 'en', displayValue: translations['english'] || 'English' },
    { value: 'de', displayValue: translations['german'] || 'German' },
    { value: 'sr', displayValue: translations['serbian'] || 'Serbian' }];
}


export const termsOfPayment = [
    { value: 'dor', displayValue: 'Due on Receipt' },
    { value: 'pia', displayValue: 'Payment in advance' },
    { value: 'eom', displayValue: 'End of Month' },
    { value: 'cod', displayValue: 'Cash on Delivery' },
    { value: 'net7', displayValue: '7 days after invoice date' },
    { value: 'net10', displayValue: '10 days after invoice date' },
    { value: 'net15', displayValue: '15 days after invoice date' },
    { value: 'net30', displayValue: '30 days after invoice date' },
    { value: 'net60', displayValue: '60 days after invoice date' },
];
